import {
    INIT_GET_SCHEDULE_AVAILABILITY,
    GET_SCHEDULE_AVAILABILITY,
    ERROR_GET_SCHEDULE_AVAILABILITY,
    INIT_GET_FILTER_SCHEDULES,
    GET_FILTER_SCHEDULES,
    ERROR_GET_FILTER_SCHEDULES,
    INIT_CONFIRM_SCHEDULE,
    CONFIRM_SCHEDULE,
    ERROR_CONFIRM_SCHEDULE,
    INIT_CHECK_SCHEDULES,
    CHECK_SCHEDULES,
    ERROR_CHECK_SCHEDULES,
    INIT_CURRENT_SCHEDULES,
    CURRENT_SCHEDULES,
    ERROR_CURRENT_SCHEDULES,
    INIT_DELETE_SCHEDULE_M,
    DELETE_SCHEDULE_M,
    ERROR_DELETE_SCHEDULE_M,
    CLEAR_DELETE_SCHEDULE_M_STATUS,
    CLEAN_ALL_SCHEDULE_MEDISMART,
    INIT_GENERATE_MEDISMART_SCHEDULE_REQUEST,
    GENERATE_MEDISMART_SCHEDULE_REQUEST_SUCCESS,
    GENERATE_MEDISMART_SCHEDULE_REQUEST_ERROR,
    CLEAR_SCHEDULE_AVAILABILITY_STATUS,
} from 'happ-redux/happ-types';

const initialState = {
    loadingCheckMedismart: false,
    loadingRequest: false,
    isSchedules: '',
    loading: false,
    specialist: null,
    days: null,
    hours: null,
    availability: false,
    currentSchedule: false,
    doctor: null,
    day: null,
    attention: null,
    linkAttention: null,
    attentionDate: null,
    filter: false,
    loadingFilter: false,
    hour: null,
    confirmDelete: null,
    scheduleRequest: null,
    loadingDelete: false,
}    
// eslint-disable-next-line import/no-anonymous-default-export
export default function(state = initialState, action){
    switch(action.type){
        case INIT_GET_SCHEDULE_AVAILABILITY:
            return {
                ...state,
                loading: true,
                isSchedules: '',
            }
        case INIT_CONFIRM_SCHEDULE:    
        case INIT_CURRENT_SCHEDULES:
            return {
                ...state,
                loading: true,
            }
        case INIT_DELETE_SCHEDULE_M:
            return {
                ...state,
                loadingDelete: true,
                confirmDelete: null,
            }
        case INIT_CHECK_SCHEDULES:
            return {
                ...state,
                loadingCheckMedismart: true,
                availability: false,
            }
        case INIT_GET_FILTER_SCHEDULES:    
            return {
                ...state,
                loadingFilter: true,
            }
        case GET_SCHEDULE_AVAILABILITY:
            return {
                ...state,
                loading: false,
                specialist: action.payload.specialist,
                availability: true,
                isSchedules: 'ok',
            }
        case ERROR_GET_SCHEDULE_AVAILABILITY:
            return {
                ...state,
                loading: false,
                specialist: null,
                availability: false,
                isSchedules: 'no-ok',
            }
        case CLEAR_SCHEDULE_AVAILABILITY_STATUS: 
            return {
                ...state,
                isSchedules: '',
            }
        case GET_FILTER_SCHEDULES:
            return {
                ...state,
                days: action.payload.days,
                hours: action.payload.hours,
                loadingFilter: false,
                filter: true,
            }    
        case ERROR_GET_FILTER_SCHEDULES:
            return {
                ...state,
                days: null,
                loadingFilter: false,
                hours: null,
                loading: false,
            }      
        case CHECK_SCHEDULES:  
            return {
                ...state,
                loadingCheckMedismart: false,
                availability: true,
            } 
        case ERROR_CHECK_SCHEDULES:  
            return {
                ...state,
                loadingCheckMedismart: false,
                availability: false,
            }            
        case CONFIRM_SCHEDULE: 
            return {
                ...state,
                loading: false,
                currentSchedule: true,
                attention: action.payload.attention,
                linkAttention: action.payload.linkAttention,
                attentionDate: action.payload.attentionDate,
                doctor: action.payload.doctor,
            } 
        case ERROR_CONFIRM_SCHEDULE: 
            return {
                ...state,
                loading: false,
                currentSchedule: false,
                attention: null,
                linkAttention: null,
                doctor: null,
                attentionDate: null,
            }  
        case CURRENT_SCHEDULES:
            return {
                ...state,
                loading: false,
                currentSchedule: true,
                doctor: action.payload.schedule.doctor,
                attentionDate: action.payload.schedule.attentionDate,
                linkAttention: action.payload.schedule.linkAttention,
                attention: action.payload.schedule.attention,
            }  
        case ERROR_CURRENT_SCHEDULES:
            return {
                ...state,
                loading: false,
                currentSchedule: false,
                doctor: null,
                attentionDate: null,
                linkAttention: null,
                attention: null,
            }  
        case DELETE_SCHEDULE_M:
            return {
                ...state,
                loadingDelete: false,
                confirmDelete: true,
                currentSchedule: false,
            }          
        case ERROR_DELETE_SCHEDULE_M:
            return {
                ...state,
                loadingDelete: false,
                confirmDelete: false,
                currentSchedule: true,
            } 
        case CLEAR_DELETE_SCHEDULE_M_STATUS: 
            return {
                ...state,
                confirmDelete: null,  
            }
        case INIT_GENERATE_MEDISMART_SCHEDULE_REQUEST: 
            return {
                ...state,
                loadingRequest: true,
                scheduleRequest: null,
            }
        case GENERATE_MEDISMART_SCHEDULE_REQUEST_SUCCESS: 
            return {
                ...state,
                loadingRequest: false,
                scheduleRequest: action.payload,
            }
        case GENERATE_MEDISMART_SCHEDULE_REQUEST_ERROR:
            return {
                ...state,
                loadingRequest: false,
                scheduleRequest: null,
            }
        case CLEAN_ALL_SCHEDULE_MEDISMART:
            return {
                loading: false,
                loadingRequest: false,
                specialist: null,
                days: null,
                hours: null,
                availability: false,
                currentSchedule: false,
                doctor: null,
                day: null,
                attention: null,
                attentionDate: null,
                filter: false,
                loadingFilter: false,
                hour: null,
                confirmDelete: null,
                scheduleRequest: null,
                isSchedules: '',
                loadingDelete: false,
            }      
        default:
            return state;
    }
}    